import { send } from 'server';

export const setAutomaticWithdrawLimits = ({ withdrawThreshold, minBalanceLimit }) => send({
    ID: 35769,
    responses: [35770, 35771],
    description: 'Set Player Automatic Withdraw Limits',
    minBalanceLimit,
    withdrawThreshold
});
